/* eslint-disable jsx-a11y/anchor-is-valid */
/*** Dependecies ***/
import React, {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'

/*** Components ***/
import {PageTitle} from '../../../_metronic/layout/core'
import Notifications from '../../components/Notifications'

/*** Resources ***/
import Notices from '../../components/Notices'
import {DashboardCard} from '../../components/DashboardCard'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {ChartsWidget6, TablesWidget7} from '../../../_metronic/partials/widgets'
import {FleksupService} from '../../services/FleksupService'
import moment from 'moment'

const staticNotifications = [
  {
    key: 'productIntegrationReport',
    type: 'warning',
    title: 'Ürün Entegrasyonu',
  },
  {
    key: 'stockIntegrationReport',
    type: 'success',
    title: 'Stok Entegrasyonu',
  },
  {
    key: 'priceIntegrationReport',
    type: 'danger',
    title: 'Fiyat Entegrasyonu',
  },
  {
    key: 'orderIntegrationReport',
    type: 'info',
    title: 'Sipariş Entegrasyonu',
  },
]

const connectionMatch: any = {
  ErpIntegration: 'erpapiConnectionStatus',
  ECommerceIntegration: 'eCommerceAPIConnectionStatus',
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const [notifications, setNotifications] = useState<any>([])
  const [pageLoading, setPageLoading] = useState(true)
  const [dashboardData, setDashboardData] = useState<any>()

  useEffect(() => {
    setPageLoading(true)
    FleksupService.getDashboard().then((res) => {
      setDashboardData(res.data.data)
      setNotifications(
        staticNotifications.map((item: any, index: number) => ({
          ...item,
          description: res.data.data[item.key],
        }))
      )
      setPageLoading(false)
    })
  }, [])

  const getRouteName = ((item:any) => {
    if(['OrderIntegration','InvoiceIntegration'].includes(item))
      return 'order'

    if(['ProductIntegration','PriceIntegration','StockIntegration','ProductUpdate','CategoryIntegration'].includes(item))
      return 'product'
  })

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      {pageLoading ? (
        <div>Yükleniyor...</div>
      ) : (
        <>
          <div className='row'>
            <div className='col-md-8'>
              <div className='row'>
                <div className='col-md-6'>
                  <DashboardCard
                    subtitle={'API Bağlantı Durumları'}
                    title={'Entegrasyon'}
                    items={dashboardData?.licences?.map((item: any, index: number) => ({
                      title: item.license_name,
                      subtitle: item.license_description,
                      content: dashboardData[connectionMatch[item.product_type]]
                        ? 'Başarılı'
                        : 'Başarısız',
                      logo: toAbsoluteUrl(`/media/brands/${item.image_file_name}`),
                      badgeClassName: `badge-${
                        dashboardData[connectionMatch[item.product_type]] ? 'success' : 'danger'
                      }`,
                    }))}
                    className='card mb-xl-8'
                    componentLink={{
                      text: 'Bağlantı Ayarları',
                      to: '/settings/api-keys',
                    }}
                  />
                </div>
                <div className='col-md-6'>
                  {dashboardData?.licences && (
                    <DashboardCard
                      subtitle={'Lisans Bitiş Tarihleri'}
                      title={'Lisanslar'}
                      items={dashboardData?.licences?.map((item: any, index: number) => ({
                        title: item.license_name,
                        subtitle: item.license_description,
                        content: moment(new Date(item.expire_date)).format('DD-MM-yyyy'),
                        logo: toAbsoluteUrl(`/media/brands/${item.image_file_name}`),
                      }))}
                      className='card mb-30'
                      componentLink={{
                        text: 'Lisanslarıma Git',
                        to: '/settings/licence',
                      }}
                    />
                  )}
                </div>
                <div className='col-md-12'>
                  {dashboardData?.failedJobReports && (
                    <DashboardCard
                      subtitle={'Görevler'}
                      title={'Başarısız İşlem Raporu'}
                      items={dashboardData?.failedJobReports.map((item: any, index: number) => ({
                        title: item.jobName,
                        link: `/integration/${getRouteName(item.jobType)}/failed-tasks?jobType=${item.jobType}`,
                        content: item.failedOperationCount,
                      }))}
                      className={'card card-stretch'}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <Notices
                title={'Duyurular'}
                items={dashboardData?.lastAnnouncements?.map((item: any, index: number) => ({
                  time: moment(new Date(item.created_date)).format('DD-MM'),
                  color: `text-${item.type}`,
                  text: item.content,
                }))}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <div className='row'>
                <div className='col-md-12'>
                  <TablesWidget7
                    companyJobs={dashboardData.companyJobs}
                    className='card-xl-stretch mb-xl-8'
                  />
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <Notifications notifications={notifications} />
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-md-8'>
              <ChartsWidget6 />
            </div>
          </div>
        </>
      )}
    </>
  )
}

export {DashboardWrapper}
